// ROUTE CONST TO PREVENT TYPO
export default {
  //  ========== CHANNEL ==========
  HOME: 'home',
  ANIMATION: 'animation',
  PR_TEMPLATES: 'premiere-pro-templates',
  AE_TEMPLATES: 'after-effects-templates',
  MOTION_TEMPLATES: 'apple-motion-templates',
  AE_PLUGIN: 'after-effects-plugins',
  THREE_D: '3d',
  VIDEO: 'video',
  STOCK_IMAGE: 'stock-image',
  SFX: 'sound-effects',
  MUSIC: 'music',
  LOTTIE: 'lottie',
  LIGHTBOX: 'lightbox',
  VIEW: 'view',
  AUDIOSEARCH: 'audiosearch',
  VISUALSEARCH: 'visualsearch',
  //  ========== ACCOUNT ==========
  LOGIN: 'login',
  SIGNUP: 'signup',
  ACCOUNT: 'account',
  //  ========== FREE ==========
  FREE: 'free', // url
  // PR_TEMPLATES: 'premiere-pro-templates', // SAME AS CHANNEL
  // AE_TEMPLATES: 'after-effects-templates', // SAME AS CHANNEL
  FCPX_TEMPLATES: 'fcpx-motion-templates',
  STOCK_FOOTAGE: 'stock-footage',
  GIFS: 'gifs',
  BG_MUSIC: 'background-music',
  //  ========== DLP, CATEGORY ==========
  DLP: 'dlp',
  CATEGORY: 'category',
  // SFX: 'sound-effects', // SAME AS CHANNEL
  // MUSIC: 'music', // SAME AS CHANNEL
  // THREE_D: '3d', // SAME AS CHA\NNEL
  // VIDEO: 'video', // SAME AS CHANNEL
  // ANIMATION: 'animation',
  PR: 'premiere-pro',
  AE: 'after-effects',
  IMAGE: 'image',
  MOTION: 'apple-motion',
  //  ========== ARTISTS ==========
  ARTISTS: 'contributors',
  ARTIST: 'artist',
  ARTIST_TEMPLATE: 'artist-template',
  ARTIST_PRICE_TEMPLATE_LIST: 'artist-price-template-list',
  ARTIST_PRICE_TEMPLATE_EDIT: 'artist-price-template-edit',
  ARTIST_PRICE_TEMPLATE_NEW: 'artist-price-template-new',
  ARTIST_DASHBOARD: 'artist-dashboard',
  ARTIST_UPLOAD: 'artist-upload',
  ARTIST_SALES: 'artist-sales',
  ARTIST_PAYOUT: 'artist-payout',
  ARTIST_SETTINGS: 'artist-settings',
  ARTIST_SALES_ON_DEMAND: 'artist-sales-list-on-demand',
  ARTIST_CREATOR_LIST: 'artist-creator-list',
  ARTIST_RELEASE_LIST: 'artist-release-list',
  ARTIST_ELEMENT_LIST: 'artist-element-list',
  ARTIST_ELEMENT_EDIT: 'artist-element-edit',
  ARTIST_COLLECTION_LIST: 'artist-collection-list',
  ARTIST_COLLECTION_EDIT: 'artist-collection-edit',
  ARTIST_COLLECTION_NEW: 'artist-collection-new',
  ARTIST_PROFILE_EDIT: 'artist-profile-edit',
  ARTIST_METADATA_IMPORT: 'artist-metadata-import',
  ARTIST_METADATA_SPECS: 'artist-metadata-specs',
  // ARTIST_REPORT_GCP: 'artist-sales-list-gcp',
  //  ========== PRODUCT ==========
  PRODUCT: 'product',
  COLLECTION: 'collection',
  PRODUCT_AE_PLUGIN: 'product-ae-plugin',
};

